module.exports = __webpack_public_path__ + "static/media/S1.9c2a5206.png";